import HomeHeader from './components/Home/HomeHeader';
import HomeMain from './components/Home/HomeMain';
import HomeFooter from './components/Home/HomeFooter';
import AboutUsHeader from './components/AboutUs/AboutUsHeader';
import AboutUsMain from './components/AboutUs/AboutUsMain';
import AboutUsFooter from './components/AboutUs/AboutUsFooter';
import AdvantageHeader from './components/Advantage/AdvantageHeader';
import AdvantageMain from './components/Advantage/AdvantageMain';
import AdvantageFooter from './components/Advantage/AdvantageFooter';
import BusinessHeader from './components/Business/BusinessHeader';
import BusinessMain from './components/Business/BusinessMain';
import BusinessFooter from './components/Business/BusinessFooter';

const layoutConfig = {
  '/': {
    header: HomeHeader,
    main: HomeMain,
    footer: HomeFooter,
  },
  '/aboutUs': {
    header: AboutUsHeader,
    main: AboutUsMain,
    footer: AboutUsFooter,
  },
  '/advantage': {
    header: AdvantageHeader,
    main: AdvantageMain,
    footer: AdvantageFooter,
  },
  '/business': {
    header: BusinessHeader,
    main: BusinessMain,
    footer: BusinessFooter,
  },
};

export default layoutConfig;
